import RecordBase from './Base';
import { useTranslation } from 'react-i18next';

export default class AddonRecord extends RecordBase {

  static defaultAttributes = {
    name:              '',
    lang:              'pt-BR',
    type:              null,
    price:             null,
    coin:              'R$',
    google_product_id: '',
    apple_product_id:  '',
    resources_size:    null,
    is_active:         true,
    partner_id:        0,
    period:            'month',
  };

  static _attributeNames = null;

  static get attributeNames(){
    const { t } = useTranslation();
    if(!this._attributeNames){
      this._attributeNames = {
        id:                t('addon.attributes.id'),
        name:              t('addon.attributes.name'),
        lang:              t('addon.attributes.lang'),
        type:              t('addon.attributes.type'),
        price:             t('addon.attributes.price'),
        coin:              t('addon.attributes.coin'),
        google_product_id: t('addon.attributes.google_product_id'),
        apple_product_id:  t('addon.attributes.apple_product_id'),
        resources_size:    t('addon.attributes.resources_size'),
        is_active:         t('addon.attributes.is_active'),
        deleted_at:        t('addon.attributes.deleted_at'),
        updated_at:        t('addon.attributes.updated_at'),
        partner_id:        t('addon.attributes.partner_id'),
        period:            t('addon.attributes.period'),
      };
    }

    return this._attributeNames;
  }

  toParams(){
    const {
      name,
      resources_size,
      lang,
      coin,
      type,
      price,
      google_product_id,
      apple_product_id,
      is_active,
      partner_id,
      period
    } = this.toObject();

    return {
      data:{
        attributes:{
          name,
          resources_size,
          lang,
          coin,
          type,
          price,
          google_product_id,
          apple_product_id,
          is_active,
          partner_id,
          period
        }
      }
    };
  }

}
